import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { TratamentosIndex } from "@/components/itv/pages/TratamentosIndex";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { breadcrumbSchema, medicalWebPageSchema, type Trilha } from "@/lib/schema";

const PATH = "/tratamentos/";
const TITLE = "Tratamentos Médicos: Nutrologia e Esporte | Dr. Thiago Viana";
const DESCRIPTION =
  "Conheça os tratamentos conduzidos pelo Dr. Thiago Viana: emagrecimento, ganho de massa, reposição hormonal, longevidade e medicina esportiva em Bauru.";

export const Route = createFileRoute("/tratamentos/")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: PATH },
  ];

  return (
    <>
      <TratamentosIndex />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
    </>
  );
}
